
<div>
  <panel-modal>
    <notifications-modal v-if="modalStateFor(vueModalID.addNewNotification).isVisible"
                         :state="modalStateFor(vueModalID.addNewNotification)"
                         :index="vueModalID.addNewNotification"
                         :key="selectedNotification.client_id"
                         @toggle-modal="hideModal(vueModalID.addNewNotification)"
                         :parent="parent"
                         :dynamic-fields-handler="dynamicFieldsHandler"
                         :permittee-options="permitteeOptions"
                         :notification="selectedNotification"></notifications-modal>
  </panel-modal>

  <panel-block id="pn-send-email" class="condition">
    <panel-item>

      <notification-display v-for="(notification, i) in notifications"
                            :notification="notification"
                            :i="i"
                            :key="notification.client_id"
                            v-on:edit:notification="editNotification"></notification-display>

      <panel-actions>
        <button @click="startNotification" type="button" class="btn grey-to-blue full-sz" id="add-notification">
          Create Notification
        </button>
      </panel-actions>
    </panel-item>
  </panel-block>
</div>
